import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-cream pt-16 pb-20 overflow-hidden" data-id="element-36">
      {/* Subtle background pattern/gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-leaf/5 via-transparent to-transparent" data-id="element-37" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-38">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-39">
          <div className="max-w-2xl" data-id="element-40">
            <FadeIn data-id="element-41">
              <div className="flex justify-center" data-id="element-42">
                <div className="inline-flex items-center space-x-2 bg-forest/10 text-forest px-4 py-2 rounded-full font-medium text-sm mb-6" data-id="element-43">
                  <ShieldCheckIcon className="w-4 h-4" data-id="element-44" />
                  <span data-id="element-45">Manual de Supervivencia para Padres</span>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-46">
              <h1 className="md:text-5xl lg:text-6xl font-extrabold text-ink mb-6 text-center text-[40px]" data-id="element-47">
                ¿Estás Nutriendo a tu Hijo o Solo{' '}
                <span className="text-forest" data-id="element-48">Llenando su Estómago?</span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-49">
              <h2 className="text-xl md:text-2xl text-ink/80 font-medium mb-8 leading-relaxed text-center" data-id="element-50">
                El manual de supervivencia para padres que quieren blindar la
                salud de sus hijos en un mundo diseñado para enfermarlos.
              </h2>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-51">
              <div className="prose prose-lg text-ink/70 mb-10 text-center" data-id="element-52">
                <p data-id="element-53">
                  Nadie te preparó para esto. En el hospital te enseñaron a
                  cambiar pañales, pero nadie te explicó cómo proteger a tu hijo
                  de una industria de miles de millones de dólares que ha
                  secuestrado su paladar y su salud.
                </p>
                <p data-id="element-54">
                  Si sientes que la hora de la cena es una zona de guerra, que
                  las etiquetas del supermercado están escritas en un idioma
                  indescifrable y que tu hijo vive en una montaña rusa de
                  azúcar...{' '}
                  <strong data-id="element-55">
                    no es tu culpa. El sistema está diseñado para que pierdas.
                  </strong>
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-56">
              <Button href="https://www.novantumnexus.com/cart/53962937205011:1" className="w-full sm:w-auto" data-id="element-57">
                BLINDAR LA SALUD DE MI HIJO
              </Button>
              <p className="mt-4 text-sm text-ink/60 font-medium text-center" data-id="element-58">
                Acceso inmediato • Formato PDF • Lectura rápida
              </p>
            </FadeIn>
          </div>

          <FadeIn delay={0.2} direction="left" className="relative lg:ml-auto" data-id="element-59">
            <div className="relative w-full max-w-lg mx-auto" data-id="element-60">
              {/* Decorative blob behind image */}
              <div className="absolute inset-0 bg-leaf/10 rounded-full blur-3xl transform scale-110" data-id="element-61" />
              <img src="https://cdn.magicpatterns.com/uploads/krkurGs47QDPrisnUcpeCj/Mockup_1_-_6to_Ebook.png" alt="Mockup del Ebook Padres Nutricionistas" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-62" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}